type SiteHost = 'EDITOR' | 'STUDIO' | 'EDITOR3';

export type GlobalWithCommonConfig = typeof globalThis & {
  commonConfig?: {
    host?: SiteHost;
    bsi?: string;
  };
};

export function getGlobalObject(): GlobalWithCommonConfig | undefined {
  if (typeof globalThis === 'object') {
    return globalThis;
  } else if (typeof self === 'object') {
    return self;
  } else if (typeof global === 'object') {
    return global;
  }
}
